import React from 'react';

const Ringover = ({ color = '#335B70', ...props }) => (
    <svg {...props} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
            fill={color}
            fillRule="evenodd"
            d="M12 22c-5.025 0-8.97-3.246-9.86-7.95-.012-.058-.028-.146-.047-.264H7.07l.05.158c.74 2.208 2.743 3.35 4.879 3.35 2.139 0 4.147-1.122 4.883-3.346l.05-.162h4.974l-.038.22C20.994 18.736 17.038 22 12 22Zm0-20c5.256 0 9.33 3.518 9.964 8.598.009.073.02.183.036.33h-4.905l-.034-.187C16.541 8.06 14.35 6.706 12 6.706c-2.323 0-4.491 1.323-5.043 3.944-.013.06-.03.154-.052.278H2c.022-.206.039-.36.053-.462C2.742 5.456 6.79 2 12 2Z"
            clipRule="evenodd"
        />
    </svg>
);

export default Ringover;
